import PropTypes from 'prop-types'
import React from 'react'

type UpNextCircleCountdownProps = {
  timeRemaining: number
  length: string
}

const UpNextCircleCountdown = ({
  timeRemaining,
  length,
}: UpNextCircleCountdownProps): JSX.Element => {
  const determineLength = length === 'full_length' ? 30 : 10
  const progress =
    timeRemaining > 0 ? 100 - (100 * timeRemaining) / determineLength : 100
  const calculatedProgress = Math.ceil(progress)
  const radius = 170 / 2
  const stroke = 12
  const normalizedRadius = radius - stroke * 2
  const circumference = normalizedRadius * 2 * Math.PI

  const strokeDashoffset = -1 * (calculatedProgress / 100) * circumference
  const trianglePoints = [
    // top left
    [radius * 0.7147, radius * 0.8324],
    // bottom left
    [radius + radius * 0.25, radius * 0.8324],
    // right
    [radius * 0.9735, radius + radius * 0.25],
  ]
  const formattedPairs = trianglePoints.map((pair) => pair.join(','))
  const formattedPoints = formattedPairs.join(' ')

  return (
    <div className="up-next-circular-progress">
      <svg height={radius * 2} width={radius * 2}>
        <polygon
          className="circular-progress-play"
          points={formattedPoints}
          strokeLinejoin="round"
          strokeWidth="1"
        />

        <g>
          <circle
            className="circular-progress-trail"
            fill="transparent"
            strokeWidth={stroke}
            strokeOpacity={1}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />

          <circle
            className="circular-progress-main"
            strokeDasharray={circumference}
            style={{
              strokeDashoffset,
              transition: 'stroke-dashoffset 1s linear',
            }}
            fill="transparent"
            strokeWidth={stroke}
            strokeOpacity={1}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </g>
      </svg>
    </div>
  )
}

UpNextCircleCountdown.propTypes = {
  timeRemaining: PropTypes.number,
  length: PropTypes.string,
}

export default UpNextCircleCountdown
